import { render, staticRenderFns } from "./InsideProductt.vue?vue&type=template&id=5b646b90&scoped=true"
import script from "./InsideProductt.vue?vue&type=script&lang=js"
export * from "./InsideProductt.vue?vue&type=script&lang=js"
import style0 from "./InsideProductt.vue?vue&type=style&index=0&id=5b646b90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b646b90",
  null
  
)

export default component.exports